/* eslint-disable @typescript-eslint/no-explicit-any */
import * as jose from 'jose';
import { LoVTab } from '../services/types';
import { ListOfValues, LoVNode } from './types';

export const handleKeyPressNumber = (e: React.KeyboardEvent) => {
  const noSpecialChars = /`|~|!|@|#|\$|%|\^|&|\*|\(|\)|\+|=|\[|\{|\]|\}|\||\\|'|<|,|\.|>|\?|\/|""|;|_|:|\D/g;
  if (noSpecialChars.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault();
  }
};

export const regexPhoneFormatter = (phone: string) => {
  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const handleKeyPressLetters = (e: React.KeyboardEvent) => {
  if (!e.key.match(/[a-z\s]/i) && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ç') {
    e.preventDefault();
  }
};

export const handleKeyPressLettersAndNumbers = (e: React.KeyboardEvent) => {
  if (!e.key.match(/^[a-zA-Z0-9_.-]*$/) && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
    e.preventDefault();
  }
};

export const parseListOfValues = (tabs: Array<LoVTab>): Array<LoVNode> => {
  const ret: Array<LoVNode> = [];

  if (tabs && tabs.length > 0) {
    tabs.forEach((tab) => {
      const values: Array<string> = tab.attributes.tabulacao_value.split('::');
      const lastIndex = values.length - 1;
      let parent: Array<LoVNode> = ret;
      values.forEach((value, index) => {
        let found = parent.find((node) => value === node.name);
        if (!found) {
          found = { name: value, subValues: [] };
          if (index === lastIndex) {
            found.tab = tab;
          }
          parent.push(found);
        }
        parent = found.subValues;
      });
    });
  }

  return ret;
};

export const convertStatusToPortuguese = (obj: any, status: string) => {
  let result;
  Object.entries(obj).forEach(([prop, val]) => {
    if (prop === status) {
      result = val;
    }
  });
  return result;
};

export const getTags = (url: string) => (url.includes('uat5') ? 'uat5' : 'prd');

export function tabulationMapper(data: any, list: any) {
  const lov = new ListOfValues(list);
  if (data.subCategory) {
    return lov.getSubcategoryNode(data.solicitationType, data.subject, data.category, data.subCategory);
  }
  if (data.category) {
    return lov.getCategoryNode(data.solicitationType, data.subject, data.category);
  }
  return lov.getSubjectNode(data.solicitationType, data.subject);
}

export const getListNode = (node: LoVNode, name: string) => {
  return node.subValues.find((value) => value.name === name);
};

export function tabulationCompanyProposalMapper(list: any) {
  const lov = new ListOfValues(list);
  const dataSolicitacao = lov.getTypeNode('Solicitação') as any;
  const dataClub = getListNode(dataSolicitacao, 'Clube Smiles Para Empresas') as any;
  const dataBenefit = getListNode(dataClub, 'Contratação de Benefício') as any;
  const dataForm = getListNode(dataBenefit, 'Formulário de Interesse');
  const tabulationTag = dataForm?.tab?.attributes?.tabulacao_tag ?? '';
  return tabulationTag;
}

export function getMemberNumber(token: string | null) {
  if (token) {
    return jose.decodeJwt(token).sub?.split('|')[2];
  }
  return '';
}
